module.exports = __webpack_public_path__ + "img/teach_img.c3d48ad8.jpg";